// extracted by mini-css-extract-plugin
export var errorsContainer = "_ru-1";
export var link = "_ru-0";